import React from 'react';
import PropTypes from 'prop-types';

const Loading = ({ loading }) => (
    !loading
        ? null
        : <div className="loader">
            <div className="loader-1" />
            <div className="loader-2" />
            <div className="loader-3" />
            <div className="loader-4" />
        </div>
);

Loading.propTypes = {
    loading: PropTypes.bool.isRequired
};

export default Loading;
